import { render, staticRenderFns } from "./ActionDialog.vue?vue&type=template&id=18080f5c&"
import script from "./ActionDialog.vue?vue&type=script&lang=ts&"
export * from "./ActionDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports